import React from 'react';
import ErrorScreen from './ErrorScreen';

class ErrorBoundary extends React.Component {
  
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if ((this.state as {
      hasError: boolean;
    }).hasError) {
      // You can customize the error message displayed to the user
      return <ErrorScreen />;
    }

    return (this.props as {
      children: React.ReactNode;
    }).children;
  }
}

export default ErrorBoundary;
